<app-pop-up [title]="'ALERGIAS DECLARADAS'" (close)="onCancelForm()" (save)="onSubmitForm()">
    <div class="flex justify-between gap-20">
        <div class="flex flex-column">
            <app-title [title]="'CATEGORIA'" [isMandatory]="data.mandatory" [isConditionFilled]="categoryValid"></app-title>
            <input type="search" class="m-b-10 m-t-5">

            <div class="allergies-container scrollbar" id="style-1">

                <div *ngFor="let item of allergiesList" class="flex align-center line table-row-even pointer"
                    (click)="checkCategory(item)">
                    <input type="checkbox" [id]="item.allergyCategory" [name]="item.allergyCategory"
                        [checked]="item.selected">
                    <span>{{ item.allergyCategory }}</span>
                </div>

            </div>
        </div>

        <div class="flex flex-column">
            <app-title [title]="'TIPOS'" [isMandatory]="data.mandatory" [isConditionFilled]="typeValid"></app-title>
            <input type="search" class="m-b-10 m-t-5">

            <div class="allergies-container scrollbar" id="style-1">

                @if (selectedCategory) {
                <div *ngFor="let subItem of selectedCategory.allergyType"
                    class="flex align-center line table-row-even pointer" (click)="checkType(subItem)">
                    <input type="checkbox" [id]="subItem.type" [name]="subItem.type" [checked]="subItem.selected">
                    <span>{{ subItem.type }}</span>
                </div>
                }

            </div>
        </div>

        <div class="display-selected-items">
            <app-title [title]="'ALERGIAS DECLARADAS'"></app-title>
        </div>
    </div>
</app-pop-up>